import Vue from 'vue'
import RootNotesMixin from 'GroomyRoot/mixins/Notes.js'
import Constants from 'Constants'

export default Vue.util.mergeOptions(RootNotesMixin, {
    methods: {
        getNotes: async function(startDate = null, endDate = null) {
            let url = Constants.NOTES_URL+"?licence_key="+Constants.USER_LICENCE_KEY
            if(startDate) url += "&start_date=" + startDate
            if(endDate) url += "&end_date=" + endDate
            
            return this.$request.request_get_api("NotesMixin::getNotes", url)
                .then(res => res.retour)
                .catch(e => {
                    console.error("NotesMixin::getNotes => ", e)
                    return null
                })
        },

        getNotesFeed: async function(page) {
            const url = Constants.NOTES_FEED_URL+`?licence_key=${Constants.USER_LICENCE_KEY}&page=${page}`
            
            return this.$request.request_get_api("NotesMixin::getNotesFeed", url)
                .then(res => res.retour)
                .catch(e => {
                    console.error("NotesMixin::getNotesFeed => ", e)
                    return null
                })
        },

        getHorseNotesFeed: async function(horse_id, page) {
            const url = this.constructRoute(Constants.NOTES_HORSE_FEED_URL, { horse_id })+`?licence_key=${Constants.USER_LICENCE_KEY}&page=${page}`
            
            return this.$request.request_get_api("NotesMixin::getHorseNotesFeed", url)
                .then(res => res.retour)
                .catch(e => {
                    console.error("NotesMixin::getHorseNotesFeed => ", e)
                    return null
                })
        },

        getNote: async function(note_id) {
            const url = this.constructRoute(Constants.NOTES_DETAILS_URL, { note_id })+"?licence_key="+Constants.USER_LICENCE_KEY
            
            return this.$request.request_get_api("NotesMixin::getNote", url)
                .then(res => res.retour)
                .catch(e => {
                    console.error("NotesMixin::getNote => ", e)
                    throw e
                })
        },

        getNoteFiles: async function(note_id) {
            const url = this.constructRoute(Constants.NOTES_FILES_URL, { note_id })+"?licence_key="+Constants.USER_LICENCE_KEY
            
            return this.$request.request_get_api("NotesMixin::getNoteFiles", url)
                .then(res => res.retour)
                .catch(e => {
                    console.error("NotesMixin::getNoteFiles => ", e)
                    throw e
                })
        },

        getNoteFileContent: async function(note_id) {
            const url = this.constructRoute(Constants.NOTES_FILE_CONTENT_URL, { note_id })+"?licence_key="+Constants.USER_LICENCE_KEY
            
            return this.$request.request_get_file_api("NotesMixin::getNote", url)
                .catch(e => {
                    console.error("NotesMixin::getNote => ", e)
                    throw e
                })
        },

        getHorseNotes: async function(horse_id, startDate = null, endDate = null) {
            let url = this.constructRoute(Constants.NOTES_HORSE_GET_URL, { horse_id })+"?licence_key="+Constants.USER_LICENCE_KEY
            if(startDate) url += "&start_date=" + startDate
            if(endDate) url += "&end_date=" + endDate

            return this.$request.request_get_api("NotesMixin::getHorseNotes", url)
                .then(res => {
                    return res.retour
                })
                .catch(e => {
                    console.error("NotesMixin::getHorseNotes => ", e)
                    throw e
                })
        },

        getPreviewType: function(mimeType) {
            if (!mimeType) return 'other'
            const mime = mimeType.toLowerCase()
            if (mime.startsWith('image/') || mime.includes('image')) return 'image'
            if (mime === 'application/pdf' || mime.includes('pdf')) return 'pdf'
            if (mime.startsWith('video/') || mime.includes('video')) return 'video'
            if (mime.startsWith('audio/') || mime.includes('audio')) return 'audio'
            return 'other'
        },

        getMimeFromFilename: function(filename) {
            if (!filename) return null
            const ext = filename.split('.').pop().toLowerCase()
            const mimeMap = {
                'png': 'image/png',
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'gif': 'image/gif',
                'webp': 'image/webp',
                'svg': 'image/svg+xml',
                'pdf': 'application/pdf',
                'mp4': 'video/mp4',
                'webm': 'video/webm',
                'mov': 'video/quicktime',
                'mp3': 'audio/mpeg',
                'wav': 'audio/wav',
                'ogg': 'audio/ogg'
            }
            return mimeMap[ext] || null
        }
    }
})